import React from 'react';
import logo from './assets/logo_white_c.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
          <p>
              Removing barriers to automated software.
          </p>
      </header>
    </div>
  );
}

export default App;
